/**
 * Utility to take care of rest requests
 */
define('atn/restUtils',['jquery', 'knockout', './utils', 'lodash'],
    function($, ko, utils, _) {
        'use strict';
        return {
            get: get,
            put: put,
            post: post,
            destroy: destroy,
            setError: setError,
            getObject: getObject
        };

        /**
         * ajax get call to fetch new data into modelObservable
         * @param  {string} url                         url of resource
         * @param  {string} modelName                   name of model
         * @param  {ko.observable} modelObservable      observable model
         * @param  {ko.observable} errorObservable      observable error error object
         * @param  {function} modelModifierFn           function to modify the model recieved
         * @param  {integer} timeout                    custom timeout for the request
         * @return {promise}                            promise object for request complete
         */
        function get(url, modelName, modelObservable, errorObservable, modelModifierFn, timeout) {
            var deferred = $.Deferred();
            errorObservable({});
            var requestUrl = (url.split('?').length >= 2) ? url : url + '?limit=5000',
                ajaxSettings = {
                    url: requestUrl,
                    type: 'GET',
                    dataType: 'json'
                };
            if (_.isNumber(timeout)) {
                ajaxSettings.timeout = timeout;
            }
            var promise = $.ajax(ajaxSettings);
            promise.done(function(response) {
                var model;
                if(response.data){
                   model = (modelName ? response.data[modelName] : response.data);
                } else if(response[modelName]){
                    model = response[modelName];
                } else{
                    model = response;
                }
                if (_.isFunction(modelModifierFn)) {
                    model = modelModifierFn(model);
                }
                if (_.isArray(model)) {
                    modelObservable(ko.mapping.fromJS(model)());
                } else {
                    modelObservable(ko.mapping.fromJS(model));
                }
                deferred.resolve(model);
            });
            promise.fail(function(xhr) {
                setError(xhr, errorObservable);
                deferred.reject(xhr);
            });
            return deferred.promise();
        }

        /**
         * ajax get call to fetch new data into modelObservable
         * @param  {string} url                         url of resource
         * @param  {string} modelName                   name of model
         * @param  {ko.observable} modelObservable      observable model
         * @param  {ko.observable} errorObservable      observable error error object
         * @param  {function} modelModifierFn           function to modify the model recieved
         * @param  {integer} timeout                    custom timeout for the request
         * @return {promise}                            promise object for request complete
         */
        function getObject(url, modelName, modelObservable, errorObservable, modelModifierFn, timeout) {
            var deferred = $.Deferred();
            errorObservable({});
            var requestUrl = (url.split('?').length >= 2) ? url : url + '?limit=5000',
                ajaxSettings = {
                    url: requestUrl,
                    type: 'GET',
                    dataType: 'json'
                };
            if (_.isNumber(timeout)) {
                ajaxSettings.timeout = timeout;
            }
            var promise = $.ajax(ajaxSettings);
            promise.done(function(response) {
                var model;
                if(response.data){
                   model = (modelName ? response.data[modelName] : response.data);
                }
                else{
                    model = response;
                }
                if (_.isFunction(modelModifierFn)) {
                    model = modelModifierFn(model);
                }
                modelObservable(model);
                deferred.resolve(model);
            });
            promise.fail(function(xhr) {
                setError(xhr, errorObservable);
                deferred.reject(xhr);
            });
            return deferred.promise();
        }

        /**
         * ajax call to put the modified model to server
         * @param  {string} url                                 url of resource
         * @param  {string} modelName                           name of model
         * @param  {function} modelDataFn                       function to modify request data
         * @param  {ko.trackableObserver} trackableObservable   trackableObservale for model to update
         * @param  {ko.observable} errorObservable              observable to track errors
         * @param  {function} modelModifierFn                   function to modify the model recieved
         * @param  {integer} timeout                            custom timeout for the request
         * @return {promise}                                    promise object for request complete
         */
        function put(url, modelName, modelDataFn, trackableObservable, errorObservable, modelModifierFn, timeout) {
            var deferred = $.Deferred();
            var data = ko.mapping.toJS(trackableObservable);
            if (_.isFunction(modelDataFn)) {
                data = modelDataFn(data, trackableObservable);
            }
            errorObservable({});
            var ajaxSettings = {
                url: url,
                type: 'PUT',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data)
            };
            if (_.isNumber(timeout)) {
                ajaxSettings.timeout = timeout;
            }
            var promise = $.ajax(ajaxSettings);
            promise.done(function(response) {
                var model;

                if(response.data){
                    model = response.data[modelName];
                } else {
                    model = response;
                }

                if (_.isFunction(modelModifierFn)) {
                    model = modelModifierFn(model);
                }
                var modified = ko.observable(ko.mapping.fromJS(model));
                ko.shallowCopy(modified, trackableObservable);
                trackableObservable.commit();
                deferred.resolve(model);
            });
            promise.fail(function(xhr) {
                setError(xhr, errorObservable);
                deferred.reject(xhr);
            });
            return deferred.promise();
        }

        /**
         * ajax call to add new item
         * @param  {string} url                         url of resource
         * @param  {string} modelName                   name of the model
         * @param  {Object} modelData                   the data of the model that has to added
         * @param  {ko.observable} modelObservable      the observable to collected newly created object
         * @param  {ko.observable} errorObservable      observable to catch errors
         * @param  {function} modelModifierFn           function to modify the model recieved
         * @param  {integer} timeout                    custom timeout for the request
         * @return {promise}                            promise object for request complete
         */
        function post(url, modelName, modelData, modelObservable, errorObservable, modelModifierFn, timeout) {
            var deferred = $.Deferred();
            errorObservable({});
            var ajaxSettings = {
                url: url,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(modelData)
            };
            if (_.isNumber(timeout)) {
                ajaxSettings.timeout = timeout;
            }
            var promise = $.ajax(ajaxSettings);
            promise.done(function(response) {
                var model;
                if(response.data){
                    model = response.data[modelName];
                } else {
                    model = response;
                }
                if (_.isFunction(modelModifierFn)) {
                    model = modelModifierFn(model);
                }
                modelObservable(ko.mapping.fromJS(model));
                deferred.resolve(model);
            });
            promise.fail(function(xhr) {
                setError(xhr, errorObservable);
                deferred.reject(xhr);
            });
            return deferred.promise();
        }

        /**
         * ajax call to remove a model
         * @param  {string} url                         url of the resource
         * @param  {string} modelName                   name of the model
         * @param  {ko.observable} errorObservable      observable to handle errors
         * @param  {function} modelModifierFn           function to modify the model recieved
         * @param  {integer} timeout                    custom timeout for the request
         * @return {promise}                            promise object for request complete
         */
        function destroy(url, modelName, errorObservable, modelModifierFn, timeout) {
            var deferred = $.Deferred();
            if (_.isFunction(errorObservable)) {
                errorObservable({});
            }
            var ajaxSettings = {
                url: url,
                type: 'DELETE',
                dataType: 'json'
            };
            if (_.isNumber(timeout)) {
                ajaxSettings.timeout = timeout;
            }
            var promise = $.ajax(ajaxSettings);
            promise.done(function(response) {
                var model;
                if(modelName){
                    model = response.data[modelName];
                    if (_.isFunction(modelModifierFn)) {
                        model = modelModifierFn(model);
                    }
                } else {
                    model = {};
                }

                deferred.resolve(model);
            });
            promise.fail(function(xhr) {
                if (_.isFunction(errorObservable)) {
                    setError(xhr, errorObservable);
                }
                deferred.reject(xhr);
            });
            return deferred.promise();
        }

        /**
         * function to set error into errorObservable form xhr object
         * @param {jquery.xhr} xhr                  xhr object given by jquery
         * @param {ko.observable} errorObservable   observable to handle errors
         */
        function setError(xhr, errorObservable) {
            var error = utils.extractError(xhr);
            errorObservable(error.message);
        }
    });
